import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import EmendasDisplay from '@/Components/emendas/EmendasDisplay';
import DocumentosDropdown from '@/Components/emendas/DocumentosDropdown/DocumentosDropdown';
import { Button } from '@/Components/ui/button';

/**
 * Página pública para consulta de Emendas Impositivas
 * Acessível sem login
 */
export default function EmendasPublicas() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header da página */}
      <header className="bg-white border-b-2 border-blue-100 shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo e título */}
            <div className="flex items-center gap-4">
              <button onClick={() => navigate('/')} type="button">
                <img
                  src="/brazao_logo.png"
                  alt="Prefeitura de Corumbá"
                  className="h-12 w-auto cursor-pointer"
                />
              </button>
              <div className="border-l-2 border-blue-600 pl-4">
                <h1 className="text-lg sm:text-xl font-bold text-blue-900">
                  Consulta Pública de Emendas
                </h1>
                <p className="text-xs sm:text-sm text-blue-600">
                  Prefeitura Municipal de Corumbá/MS
                </p>
              </div>
            </div>
            
            {/* Dropdown de Documentos OSC */}
            <DocumentosDropdown />
          </div>
        </div>
      </header>

      {/* Conteúdo principal - Componente de Emendas */}
      <main>
        <EmendasDisplay />
      </main>

      {/* Footer */}
      <footer className="py-8 bg-white border-t-2 border-blue-100 mt-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:grid lg:grid-cols-3 items-center gap-6">
            
            {/* Brasão + Nome do Sistema */}
            <div className="flex items-center space-x-4 lg:justify-self-start">
              <img 
                src="/brazao_logo.png" 
                alt="Prefeitura de Corumbá" 
                className="h-12 w-auto"
              />
              <div className="border-l-2 border-blue-600 pl-4">
                <p className="text-xs text-blue-600">Prefeitura Municipal de Corumbá/MS</p>
              </div>
            </div>
            
            {/* Copyright - Centralizado */}
            <div className="text-slate-600 text-xs font-medium whitespace-nowrap lg:justify-self-center">
              © {new Date().getFullYear()} Todos os direitos reservados
            </div>
            
            {/* Espaço vazio para balancear o grid */}
            <div className="hidden lg:block"></div>
          </div>
        </div>
      </footer>
    </div>
  );
}
